module.exports = __webpack_public_path__ + "img/friends.b63f96aa.png";